/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetProductsToWriteOffDocument = gql`
    query getProductsToWriteOff($companyId: Int!, $branchId: Int!, $bookingUuid: Uuid) {
  user(companyId: $companyId) {
    company(id: $companyId, deleted: false) {
      branches(id: $branchId) {
        bookingsList(uuid: $bookingUuid) {
          technologicalMaps(inStockProducts: true, branchId: $branchId) {
            id
            name
            deleted
            technologicalMapProductRelations(inStockProducts: true, branchId: $branchId) {
              id
              requiredQuantity
              unit {
                id
                name
              }
              product {
                storages(branchId: $branchId) {
                  id
                  name
                  deleted
                  default
                }
                cost
                deleted
                id
                price
                name
                sku
                deleted
                unit {
                  id
                  name
                }
                units {
                  id
                  name
                }
                unitGroup {
                  id
                  name
                  units {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductsToWriteOffQuery__
 *
 * To run a query within a React component, call `useGetProductsToWriteOffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsToWriteOffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsToWriteOffQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      bookingUuid: // value for 'bookingUuid'
 *   },
 * });
 */
export function useGetProductsToWriteOffQuery(baseOptions: Apollo.QueryHookOptions<GetProductsToWriteOffQuery, GetProductsToWriteOffQueryVariables> & ({ variables: GetProductsToWriteOffQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsToWriteOffQuery, GetProductsToWriteOffQueryVariables>(GetProductsToWriteOffDocument, options);
      }
export function useGetProductsToWriteOffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsToWriteOffQuery, GetProductsToWriteOffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsToWriteOffQuery, GetProductsToWriteOffQueryVariables>(GetProductsToWriteOffDocument, options);
        }
export function useGetProductsToWriteOffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsToWriteOffQuery, GetProductsToWriteOffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsToWriteOffQuery, GetProductsToWriteOffQueryVariables>(GetProductsToWriteOffDocument, options);
        }
export type GetProductsToWriteOffQueryHookResult = ReturnType<typeof useGetProductsToWriteOffQuery>;
export type GetProductsToWriteOffLazyQueryHookResult = ReturnType<typeof useGetProductsToWriteOffLazyQuery>;
export type GetProductsToWriteOffSuspenseQueryHookResult = ReturnType<typeof useGetProductsToWriteOffSuspenseQuery>;
export type GetProductsToWriteOffQueryResult = Apollo.QueryResult<GetProductsToWriteOffQuery, GetProductsToWriteOffQueryVariables>;
export const GetProductListWriteOffPageDocument = gql`
    query getProductListWriteOffPage($companyId: Int!, $branchId: Int, $itemsPerPage: Int, $page: Int, $search: String, $categoryId: Int, $brand: String) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      productsList(
        inStock: true
        itemsPerPage: $itemsPerPage
        page: $page
        search: $search
        categoryId: $categoryId
        brand: $brand
        branchId: $branchId
      ) {
        currentPage
        itemsPerPage
        pageCount
        totalCount
        items {
          name
          brand
          productCategoryNew {
            id
            name
            deleted
          }
          cost
          deleted
          id
          deleted
          price
          sku
          barcode
          storages(branchId: $branchId) {
            id
            name
            deleted
            default
          }
          units {
            id
            name
          }
          unit {
            id
            name
          }
          unitGroup {
            id
            name
            units {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductListWriteOffPageQuery__
 *
 * To run a query within a React component, call `useGetProductListWriteOffPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductListWriteOffPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductListWriteOffPageQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      categoryId: // value for 'categoryId'
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useGetProductListWriteOffPageQuery(baseOptions: Apollo.QueryHookOptions<GetProductListWriteOffPageQuery, GetProductListWriteOffPageQueryVariables> & ({ variables: GetProductListWriteOffPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductListWriteOffPageQuery, GetProductListWriteOffPageQueryVariables>(GetProductListWriteOffPageDocument, options);
      }
export function useGetProductListWriteOffPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductListWriteOffPageQuery, GetProductListWriteOffPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductListWriteOffPageQuery, GetProductListWriteOffPageQueryVariables>(GetProductListWriteOffPageDocument, options);
        }
export function useGetProductListWriteOffPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductListWriteOffPageQuery, GetProductListWriteOffPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductListWriteOffPageQuery, GetProductListWriteOffPageQueryVariables>(GetProductListWriteOffPageDocument, options);
        }
export type GetProductListWriteOffPageQueryHookResult = ReturnType<typeof useGetProductListWriteOffPageQuery>;
export type GetProductListWriteOffPageLazyQueryHookResult = ReturnType<typeof useGetProductListWriteOffPageLazyQuery>;
export type GetProductListWriteOffPageSuspenseQueryHookResult = ReturnType<typeof useGetProductListWriteOffPageSuspenseQuery>;
export type GetProductListWriteOffPageQueryResult = Apollo.QueryResult<GetProductListWriteOffPageQuery, GetProductListWriteOffPageQueryVariables>;
export const GetProductsByOperationNumberDocument = gql`
    query getProductsByOperationNumber($companyId: Int!, $branchId: Int, $operationNumber: Uuid) {
  user(companyId: $companyId) {
    id
    company(id: $companyId, deleted: false) {
      branches(id: $branchId) {
        storageProductRelationHistoryList(operationNumber: $operationNumber) {
          techMap {
            id
            name
          }
          writeOffEditUnits {
            name
            id
          }
          id
          operationNumber
          historyAction
          employee {
            id
          }
          historyCreator {
            id
          }
          quantity
          operationQuantity
          operationUnit {
            id
            name
          }
          unit {
            id
            name
            unitGroup {
              units {
                name
                id
              }
            }
          }
          storage {
            id
            name
          }
          product {
            id
            name
            sku
            brand
            barcode
            productCategoryNew {
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductsByOperationNumberQuery__
 *
 * To run a query within a React component, call `useGetProductsByOperationNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsByOperationNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsByOperationNumberQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      operationNumber: // value for 'operationNumber'
 *   },
 * });
 */
export function useGetProductsByOperationNumberQuery(baseOptions: Apollo.QueryHookOptions<GetProductsByOperationNumberQuery, GetProductsByOperationNumberQueryVariables> & ({ variables: GetProductsByOperationNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsByOperationNumberQuery, GetProductsByOperationNumberQueryVariables>(GetProductsByOperationNumberDocument, options);
      }
export function useGetProductsByOperationNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsByOperationNumberQuery, GetProductsByOperationNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsByOperationNumberQuery, GetProductsByOperationNumberQueryVariables>(GetProductsByOperationNumberDocument, options);
        }
export function useGetProductsByOperationNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsByOperationNumberQuery, GetProductsByOperationNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsByOperationNumberQuery, GetProductsByOperationNumberQueryVariables>(GetProductsByOperationNumberDocument, options);
        }
export type GetProductsByOperationNumberQueryHookResult = ReturnType<typeof useGetProductsByOperationNumberQuery>;
export type GetProductsByOperationNumberLazyQueryHookResult = ReturnType<typeof useGetProductsByOperationNumberLazyQuery>;
export type GetProductsByOperationNumberSuspenseQueryHookResult = ReturnType<typeof useGetProductsByOperationNumberSuspenseQuery>;
export type GetProductsByOperationNumberQueryResult = Apollo.QueryResult<GetProductsByOperationNumberQuery, GetProductsByOperationNumberQueryVariables>;
export const WriteOffProductsDocument = gql`
    mutation writeOffProducts($branchId: Int!, $bookingUuid: Uuid!, $input: ProductWriteOffContainerInput!) {
  writeOffProducts(branchId: $branchId, bookingUuid: $bookingUuid, input: $input)
}
    `;
export type WriteOffProductsMutationFn = Apollo.MutationFunction<WriteOffProductsMutation, WriteOffProductsMutationVariables>;

/**
 * __useWriteOffProductsMutation__
 *
 * To run a mutation, you first call `useWriteOffProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteOffProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeOffProductsMutation, { data, loading, error }] = useWriteOffProductsMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      bookingUuid: // value for 'bookingUuid'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWriteOffProductsMutation(baseOptions?: Apollo.MutationHookOptions<WriteOffProductsMutation, WriteOffProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WriteOffProductsMutation, WriteOffProductsMutationVariables>(WriteOffProductsDocument, options);
      }
export type WriteOffProductsMutationHookResult = ReturnType<typeof useWriteOffProductsMutation>;
export type WriteOffProductsMutationResult = Apollo.MutationResult<WriteOffProductsMutation>;
export type WriteOffProductsMutationOptions = Apollo.BaseMutationOptions<WriteOffProductsMutation, WriteOffProductsMutationVariables>;
export const UpdateWriteOffProductsDocument = gql`
    mutation updateWriteOffProducts($branchId: Int!, $bookingUuid: Uuid!, $operationNumber: Uuid, $input: ProductWriteOffContainerInput!, $employeeId: Int!) {
  updateWriteOffProducts(
    branchId: $branchId
    bookingUuid: $bookingUuid
    input: $input
    operationNumber: $operationNumber
    employeeId: $employeeId
  )
}
    `;
export type UpdateWriteOffProductsMutationFn = Apollo.MutationFunction<UpdateWriteOffProductsMutation, UpdateWriteOffProductsMutationVariables>;

/**
 * __useUpdateWriteOffProductsMutation__
 *
 * To run a mutation, you first call `useUpdateWriteOffProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWriteOffProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWriteOffProductsMutation, { data, loading, error }] = useUpdateWriteOffProductsMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      bookingUuid: // value for 'bookingUuid'
 *      operationNumber: // value for 'operationNumber'
 *      input: // value for 'input'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useUpdateWriteOffProductsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWriteOffProductsMutation, UpdateWriteOffProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWriteOffProductsMutation, UpdateWriteOffProductsMutationVariables>(UpdateWriteOffProductsDocument, options);
      }
export type UpdateWriteOffProductsMutationHookResult = ReturnType<typeof useUpdateWriteOffProductsMutation>;
export type UpdateWriteOffProductsMutationResult = Apollo.MutationResult<UpdateWriteOffProductsMutation>;
export type UpdateWriteOffProductsMutationOptions = Apollo.BaseMutationOptions<UpdateWriteOffProductsMutation, UpdateWriteOffProductsMutationVariables>;
export type GetProductsToWriteOffQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  bookingUuid?: Types.InputMaybe<Types.Scalars['Uuid']['input']>;
}>;


export type GetProductsToWriteOffQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', bookingsList?: Array<{ __typename?: 'BookingMainProxy', technologicalMaps?: Array<{ __typename?: 'TechnologicalMapProxy', id: number, name: string, deleted: boolean, technologicalMapProductRelations?: Array<{ __typename?: 'TechnologicalMapProductRelationProxy', id: number, requiredQuantity?: number | null, unit?: { __typename?: 'UnitProxy', id: number, name: string } | null, product?: { __typename?: 'ProductProxy', cost?: string | null, deleted: boolean, id: number, price: string, name: string, sku?: string | null, storages?: Array<{ __typename?: 'StorageProxy', id: number, name: string, deleted: boolean, default: boolean }> | null, unit?: { __typename?: 'UnitProxy', id: number, name: string } | null, units?: Array<{ __typename?: 'UnitProxy', id: number, name: string }> | null, unitGroup?: { __typename?: 'UnitGroupProxy', id: number, name: string, units?: Array<{ __typename?: 'UnitProxy', id: number, name: string }> | null } | null } | null }> | null }> | null }> | null }> | null } | null } | null };

export type GetProductListWriteOffPageQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  categoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  brand?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductListWriteOffPageQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', productsList?: { __typename?: 'ProductPaginated', currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, totalCount?: number | null, items?: Array<{ __typename?: 'ProductProxy', name: string, brand?: string | null, cost?: string | null, deleted: boolean, id: number, price: string, sku?: string | null, barcode?: string | null, productCategoryNew?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string, deleted: boolean } | null, storages?: Array<{ __typename?: 'StorageProxy', id: number, name: string, deleted: boolean, default: boolean }> | null, units?: Array<{ __typename?: 'UnitProxy', id: number, name: string }> | null, unit?: { __typename?: 'UnitProxy', id: number, name: string } | null, unitGroup?: { __typename?: 'UnitGroupProxy', id: number, name: string, units?: Array<{ __typename?: 'UnitProxy', id: number, name: string }> | null } | null }> | null } | null } | null } | null };

export type GetProductsByOperationNumberQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  operationNumber?: Types.InputMaybe<Types.Scalars['Uuid']['input']>;
}>;


export type GetProductsByOperationNumberQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', storageProductRelationHistoryList?: Array<{ __typename?: 'StorageProductRelationHistoryProxy', id: number, operationNumber?: any | null, historyAction?: Types.StorageProductRelationHistoryAction | null, quantity?: any | null, operationQuantity?: number | null, techMap?: { __typename?: 'TechnologicalMapProxy', id: number, name: string } | null, writeOffEditUnits?: Array<{ __typename?: 'UnitProxy', name: string, id: number }> | null, employee?: { __typename?: 'EmployeeProxy', id: number } | null, historyCreator?: { __typename?: 'EmployeeProxy', id: number } | null, operationUnit?: { __typename?: 'UnitProxy', id: number, name: string } | null, unit?: { __typename?: 'UnitProxy', id: number, name: string, unitGroup?: { __typename?: 'UnitGroupProxy', units?: Array<{ __typename?: 'UnitProxy', name: string, id: number }> | null } | null } | null, storage?: { __typename?: 'StorageProxy', id: number, name: string } | null, product?: { __typename?: 'ProductProxy', id: number, name: string, sku?: string | null, brand?: string | null, barcode?: string | null, productCategoryNew?: { __typename?: 'ProductCategoryNewProxy', name: string } | null } | null }> | null }> | null } | null } | null };

export type WriteOffProductsMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  bookingUuid: Types.Scalars['Uuid']['input'];
  input: Types.ProductWriteOffContainerInput;
}>;


export type WriteOffProductsMutation = { __typename?: 'Mutation', writeOffProducts: boolean };

export type UpdateWriteOffProductsMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  bookingUuid: Types.Scalars['Uuid']['input'];
  operationNumber?: Types.InputMaybe<Types.Scalars['Uuid']['input']>;
  input: Types.ProductWriteOffContainerInput;
  employeeId: Types.Scalars['Int']['input'];
}>;


export type UpdateWriteOffProductsMutation = { __typename?: 'Mutation', updateWriteOffProducts: boolean };
